import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { OrthoPhotoDto } from '../bo/orthophoto';

class MapMetadata{
    public bounds: number[];
    public center: number[];
    public tiles: string[];
}

@Injectable({
    providedIn: 'root'
})
export class OrthophotoMapService {

    private mapBoxPublicKey ='';

    constructor(private readonly ExploreHttpClient: HttpService, private readonly httpClient: HttpClient) {
         this.ExploreHttpClient.get<string>('Config/mapBoxPublicKey').toPromise().then((data) => {
            this.mapBoxPublicKey = data;    
            console.log("map key received");
        })
        .catch((error) => {
            console.error("Error while fetching map key");
        });
    }
    
    async getOrthophotoMaps(siteId: number): Promise<OrthoPhotoDto[]> {
        try {
            const maps = await this.ExploreHttpClient.get<OrthoPhotoDto[]>('sites/' + siteId + '/map').toPromise();
            
            for (const map of maps) {
                // Récupérer les métadonnées pour TOUTES les orthophotos, pas seulement les visibles
                try {
                    const metadata = await this.getTileMetadata(map.tileSetId);
                    map.bounds = metadata.bounds;
                    map.center = metadata.center;
                    map.tiles = `http://api.mapbox.com/v4/${map.tileSetId}/{z}/{x}/{y}.png?access_token=${this.mapBoxPublicKey}`
                } catch (error) {
                    console.error("Error while fetching metadata for map " + map.tileSetId);
                }
            }
            
            return maps;
        } catch (error) {
            console.error("Error while fetching orthophoto maps for site " + siteId);
            throw error;
        }
    }

    private async getTileMetadata(tilesetId: string): Promise<MapMetadata>{
        if(this.mapBoxPublicKey !== ''){
            return this.httpClient.get<MapMetadata>(`https://api.mapbox.com/v4/${tilesetId}.json?access_token=${this.mapBoxPublicKey}`).toPromise();
        }
        else{
            return Promise.reject("Mapbox public key not set");
        }
    }
    async getMapBoxPublicKey(): Promise<string> {
        
      return this.ExploreHttpClient.get<string>('Config/mapBoxPublicKey').toPromise();
    }

    // getAllOrthophotoMaps(): Observable<any[]> {
    //     return this.http.get<any[]>(this.baseUrl);
    // }

    // addOrthophotoMap(mapData: any): Observable<any> {
    //     return this.http.post(this.baseUrl, mapData);
    // }

    // updateOrthophotoMap(id: string, mapData: any): Observable<any> {
    //     return this.http.put(`${this.baseUrl}/${id}`, mapData);
    // }

    // deleteOrthophotoMap(id: string): Observable<any> {
    //     return this.http.delete(`${this.baseUrl}/${id}`);
    // }
}